import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-spending-requests',
  size: 'full',
  children: {
    newRequest: { path: 'new-request', size: 'full' },
    detail: {
      path: ':id',
      size: 'full',
      children: {
        summary: {
          path: 'summary',
          size: 'full',
        },
        attachments: {
          path: 'attachments',
          size: 'full',
        },
        comments: {
          path: 'comments',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
